import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LocalStorageService } from '../utility/localStorageService';
import * as moment from 'moment';
import { LeadFilter } from '../shared/models/lead-filter';
import { LeadService } from '../shared/services/lead.services';
import { TblLead } from '../shared/models/leads';
import { LeadStatusService } from '../shared/services/leadStatus.services';
import { TblLeadStatus } from '../shared/models/leadstatus';
import { PagerService } from '../shared/pagination';
import { BulkReassignDialogComponent } from '../shared/dialogs/bulk-reassign-dialog/bulk-reassign-dialog.component';

@Component({
  selector: 'app-bulk-reassign-leads',
  templateUrl: './bulk-reassign-leads.component.html',
  styleUrls: ['./bulk-reassign-leads.component.css']
})
export class BulkReassignLeadsComponent implements OnInit {
  userType: string;
  leadFilter: LeadFilter
  fromDate: string
  leads: TblLead[];
  leadsFullData: TblLead[];
  statusWiseLeads: { name: string; value: number; }[];
  listStatus: string[]
  listSubStatus: string[]
  listState: string[]
  listCity: string[]
  listCounsellor: any[] = []
  listSource: string[];
  androidOs: boolean = false
  filterClicked: boolean = false
  leadStatus: TblLeadStatus[];
  isRememberChecked: any;
  pager: any = {};
  private allItems: any[];
  pagedItems: any[];
  selectedLeads: Set<number> = new Set(); // Track selected lead IDs across all pages
  selectAllCheckbox: boolean = false;

  constructor(
    private localStorage: LocalStorageService,
    private _leadservices: LeadService,
    private leadStatusService: LeadStatusService,
    private pagerService: PagerService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.userType = this.localStorage.get("userType")
    if (this.localStorage.get("osType") == "Android") {
      this.androidOs = true
    }
    else {
      this.androidOs = false
    }
    this.leadStatusService.getAllLeadStatus().subscribe(resp => {
      this.leadStatus = resp;
      //this.counsellors = this.counsellors.filter((fl) => fl.userType==="Counsellor");
    });
    this.fromDate = this.localStorage.get("showMeLeadsFromDate")

    this.leadFilter = new LeadFilter()
    this.leadFilter.fromDate = (moment(new Date(this.fromDate))).format('YYYY-MM-DD')
    this.leadFilter.toDate = (moment(new Date())).format('YYYY-MM-DD')
    this.leadFilter.state = "All"
    this.leadFilter.city = "All"
    this.leadFilter.status = "All"
    this.leadFilter.subStatus = "All"
    this.leadFilter.assignedTo = "All"
    this.leadFilter.leadSource = "All"

    this.leadFilter.userRefNo = this.localStorage.get("refNo")
    this.getAllData();
  }
  getAllData() {
    let refNo: number = 0;
    if (this.localStorage.get("userType") != "Admin")
      refNo = Number(this.localStorage.get("refNo"));
    else
      refNo = 0
    this._leadservices.getAllLeadsByuserId(refNo, this.fromDate).subscribe(resp => {
      if (resp.length > 0) {
        this.leads = resp
        let cnt = 0;
        console.log(this.leads)

        this.leadsFullData = resp
        this.listStatus = []
        this.listSubStatus = []
        this.listCity = []
        this.listState = []
        this.listSource = []
        this.listCounsellor = []

        this.leads.forEach(e => {
          let found = false
          for (let i = 0; i < this.listStatus.length; i++) {
            if (e.status == this.listStatus[i]) {
              found = true
            }

          }
          if (found == false) {
            this.listStatus.push(e.status)
          }
          found = false
          for (let i = 0; i < this.listSubStatus.length; i++) {
            if (e.subStatus == this.listSubStatus[i])
              found = true
          }

          if (found == false) {
            this.listSubStatus.push(e.subStatus)
          }
          found = false
          for (let i = 0; i < this.listState.length; i++) {
            if (e.stateName == this.listState[i])
              found = true
          }
          if (found == false) {
            this.listState.push(e.stateName)
          }
          found = false
          for (let i = 0; i < this.listCity.length; i++) {
            if (e.cityName == this.listCity[i])
              found = true
          }
          if (found == false) {
            this.listCity.push(e.cityName)
          }
          found = false
          for (let i = 0; i < this.listSource.length; i++) {
            if (e.source == this.listSource[i])
              found = true
          }
          if (found == false) {
            this.listSource.push(e.source)
          }
          found = false
          for (let i = 0; i < this.listCounsellor.length; i++) {
            if (e.assignToCounsellor == this.listCounsellor[i].name)
              found = true
          }
          if (found == false && e.assignToCounsellor) {
            this.listCounsellor.push({name: e.assignToCounsellor, userRefNo: e.userRefNo})
          }
        })
        // Clean up the counsellor list - remove null, undefined, and empty strings
        this.listCounsellor = this.listCounsellor.filter(c => c && c.name && c.name.trim() && c.name !== 'null' && c.name !== 'undefined')
        console.log("Final Counsellor List:", this.listCounsellor);
      }

    });




  }

  checkBoxClicked() {
    // Check if any leads are selected
    if (this.selectedLeads.size === 0) {
      alert("Please select at least one lead to reassign");
      return;
    }

    // Check and clean the counsellor list
    const validCounsellors = this.listCounsellor.filter(c => c && c.name && c.name.trim() && c.name !== 'null' && c.name !== 'undefined');
    
    if (!validCounsellors || validCounsellors.length === 0) {
      alert("No counsellors available. Please filter leads first.");
      return;
    }

    // Convert selected lead IDs to array
    const selectedLeadsArray = Array.from(this.selectedLeads);
    
    // Log the selected leads to the console
    console.log("=== Re-Assign Dialog Opening ===");
    console.log("Selected Leads:", selectedLeadsArray);
    console.log("Number of selected leads:", this.selectedLeads.size);
    console.log("Cleaned Counsellor List:", validCounsellors);
    console.log("Cleaned Counsellor List length:", validCounsellors.length);

    // Open the dialog to select counsellor
    const dialogRef = this.dialog.open(BulkReassignDialogComponent, {
      width: '500px',
      maxWidth: '90vw',
      minWidth: '300px',
      disableClose: false,
      data: { counsellors: validCounsellors }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("Dialog result:", result);
      if (result && result.action === 'assign' && result.selectedCounsellor) {
        console.log("Reassigning to:", result.selectedCounsellor);
        this.reassignLeads(selectedLeadsArray, result.selectedCounsellor);
      } else {
        console.log("Dialog cancelled or no selection made");
      }
    });
  }
  filterLeads() {
    this.leads = this.leadsFullData;
    this.filterClicked = true
    console.log(this.leads)
    if (this.leadFilter.state != 'All') {
      this.leads = this.leads.filter((ld) => ld.stateName.includes(this.leadFilter.state));
    }
    if (this.leadFilter.city != 'All') {
      this.leads = this.leads.filter((ld) => ld.cityName.includes(this.leadFilter.city));
    }
    if (this.leadFilter.status != 'All') {
      this.leads = this.leads.filter((ld) => ld.status.includes(this.leadFilter.status));
    }
    if (this.leadFilter.subStatus != 'All') {
      this.leads = this.leads.filter((ld) => ld.subStatus.includes(this.leadFilter.subStatus));
    }
    if (this.leadFilter.assignedTo != 'All') {
      this.leads = this.leads.filter((ld: TblLead) => ld.assignToCounsellor === this.leadFilter.assignedTo);
    }
    if (this.leadFilter.leadSource != 'All') {
      this.leads = this.leads.filter(ld => ld.source.includes(this.leadFilter.leadSource));
    }
    let dataFilt: TblLead[] = []
    this.leads.forEach(e => {
      if (e.leadDate.split("-")[2] + e.leadDate.split("-")[1] + e.leadDate.split("-")[0] >= this.leadFilter.fromDate.split("-")[0] + this.leadFilter.fromDate.split("-")[1] + this.leadFilter.fromDate.split("-")[2] &&
        e.leadDate.split("-")[2] + e.leadDate.split("-")[1] + e.leadDate.split("-")[0] <= this.leadFilter.toDate.split("-")[0] + this.leadFilter.toDate.split("-")[1] + this.leadFilter.toDate.split("-")[2]) {
        dataFilt.push(e)
      }
    });
    this.leads = dataFilt

    this.statusWiseLeads = [{ name: 'All', value: 0 }]
    let cnt = 0;
    this.leads.forEach(e => {
      let notFound: Boolean = true
      cnt++;
      this.statusWiseLeads.forEach(f => {
        if (e.status == f.name) {
          f.value++;
          notFound = false
        }
      })
      if (notFound) {
        this.statusWiseLeads.push({ name: e.status, value: 1 })
      }
    })
    this.statusWiseLeads.forEach(f => {
      if (f.name == "All")
        f.value = cnt;
    });
    this.setPage(1);
  }

  setPage(page: number) {
    this.allItems = this.leads;
    this.pager = this.pagerService.getPager(this.allItems.length, page, 4);
    this.pagedItems = this.allItems.slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.updateSelectAllCheckboxState(); // Update checkbox state for current page
  }

  reassignLeads(selectedLeads: number[], counsellor: any) {
    console.log("Reassigning leads:", selectedLeads, "to counsellor:", counsellor);
    if (!counsellor || !counsellor.name || !counsellor.userRefNo) {
      alert('Invalid counsellor data');
      return;
    }
    
    this._leadservices.reassignLeads(selectedLeads, counsellor.name, counsellor.userRefNo).subscribe(
      (resp) => {
        console.log('Reassignment response:', resp);
        if (resp && resp.status === 'success') {
          alert(resp.description || 'Leads reassigned successfully');
          this.getAllData();
          // Clear selections after successful reassignment
          this.selectedLeads.clear();
          this.selectAllCheckbox = false;
        } else {
          alert('Failed to reassign leads: ' + (resp?.description || 'Unknown error'));
        }
      },
      (error) => {
        console.error('Error reassigning leads:', error);
        let errorMessage = 'Unknown error';
        
        if (error) {
          // Try to extract error message from various possible structures
          if (typeof error === 'string') {
            errorMessage = error;
          } else if (error.error && typeof error.error === 'string') {
            errorMessage = error.error;
          } else if (error.error && error.error.description) {
            errorMessage = error.error.description;
          } else if (error.error && error.error.message) {
            errorMessage = error.error.message;
          } else if (error.error && error.error.Message) {
            errorMessage = error.error.Message;
          } else if (error.message) {
            errorMessage = error.message;
          } else if (error.statusText) {
            errorMessage = error.statusText;
          }
        }
        
        alert('Error reassigning leads: ' + errorMessage);
      }
    );
  }

  selectAll(event: any) {
    const isChecked = event.target.checked;
    if (isChecked) {
      // Select all leads across all pages
      this.leads.forEach((item) => {
        this.selectedLeads.add(item.refNo);
      });
      this.selectAllCheckbox = true;
      console.log("Selected all leads:", this.selectedLeads);
    } else {
      // Deselect all leads across all pages
      this.selectedLeads.clear();
      this.selectAllCheckbox = false;
      console.log("Deselected all leads");
    }
  }

  isLeadSelected(refNo: number): boolean {
    return this.selectedLeads.has(refNo);
  }

  toggleLeadSelection(refNo: number, isChecked: boolean) {
    if (isChecked) {
      this.selectedLeads.add(refNo);
    } else {
      this.selectedLeads.delete(refNo);
    }
    // Update selectAll checkbox state based on current page selection
    this.updateSelectAllCheckboxState();
  }

  updateSelectAllCheckboxState() {
    if (this.pagedItems && this.pagedItems.length > 0) {
      const allPageItemsSelected = this.pagedItems.every(item => this.selectedLeads.has(item.refNo));
      this.selectAllCheckbox = allPageItemsSelected;
    }
  }
}
